import { hiddenBannerLocales } from '../cmp/constants';
import { createConsentDetails, createConsentTracker } from './Consent';

const createConsentEventHandlers = (didomiUtils, moduleName, moduleVersion) => {
  let notificationRevision = 0;

  const notifyConsentChange = () => {
    const revision = ++notificationRevision;
    const details = createConsentDetails(
      didomiUtils.getCurrentUserStatusFromDidomi(),
      moduleName,
      moduleVersion
    );
    didomiUtils.onChangeCallback();
    // A callback can synchronously publish a newer consent change.
    if (revision !== notificationRevision) {
      return;
    }
    didomiUtils.dispatchUserConsentDomainEvent(
      moduleName,
      moduleVersion,
      details
    );
    if (revision !== notificationRevision) {
      return;
    }
    didomiUtils.consentObserver.notifyConsentChange(details);
  };

  const consent = createConsentTracker({
    notifyConsentChange,
    hasConsentCookie: () => didomiUtils.isDidomiTokenCookieSet(),
    notifyExistingConsent: () => didomiUtils.onChangeCallback(),
  });

  const onConsentChanged = () => {
    const status = didomiUtils.getCurrentUserStatusFromDidomi();
    if (!consent.shouldNotifyConsentChange(status)) {
      return;
    }
    didomiUtils.saveUserStatus();
    notifyConsentChange();
  };

  const onNoticeShown = () => {
    consent.onNoticeShown(didomiUtils.getCurrentUserStatusFromDidomi());
  };

  const onReady = () => {
    consent.onReady(didomiUtils.getCurrentUserStatusFromDidomi());
  };

  return { onConsentChanged, onNoticeShown, onReady };
};

export const registerDidomiEvents = (
  didomiUtils,
  { locale, moduleName, moduleVersion }
) => {
  if (typeof window === 'undefined') {
    return;
  }
  const {
    onConsentChanged,
    onNoticeShown,
    onReady,
  } = createConsentEventHandlers(didomiUtils, moduleName, moduleVersion);

  window.didomiEventListeners = window.didomiEventListeners || [];
  window.didomiEventListeners.push(
    { event: 'consent.changed', listener: onConsentChanged },
    { event: 'notice.shown', listener: onNoticeShown }
  );

  window.didomiOnReady = window.didomiOnReady || [];
  window.didomiOnReady.push(onReady, didomiUtils.checkWebViewConsent);
  if (!hiddenBannerLocales.has(locale)) {
    return;
  }
  window.didomiOnReady.push(didomiUtils.agreeToAllIfBannerHidden);
};
